import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Image } from 'react-bootstrap'
import './Carousel.css';
import { showCallMeModal } from '../../actions/modalActions';
import { navigateTo } from '../../actions/navigationActions';
import { PERSONAL_INFO } from '../../routes/routes';
import { addProduct } from '../../actions/salesActions';
import { PRODUCT_COMPREHENSIVE_CAR } from '../../constants/constants';

class Carousel extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.addProduct = this.addProduct.bind(this);
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    addProduct(product) {
        this.props.dispatchAddProduct(PRODUCT_COMPREHENSIVE_CAR);
    }

    render() {
        return (
            <>
                <div className="d-none d-lg-block d-md-none d-xl-none">
                    <div id="carouselDesktop" className="carousel slide mt-4" data-ride="carousel" data-pause="hover" data-touch="true">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="carousels-background-desktop">
                                    <div className="row pb-3">
                                        <div className="col-lg-6 col-sm-6 mt-xl-2 mt-md-2 mt-sm-2 mt-2 ">
                                            <Image src="./images/image-carousel@2x.png" className="img-fluid" />
                                        </div>
                                        <div className="col-lg-6 col-sm-6 mt-xl-2 mt-md-2 mt-sm-2 mt-2 pl-0 pr-3">
                                            <h2 className="mb-2">Super cheap car<br /> insurance premiums</h2>
                                            <p>That decrease monthly</p>
                                            <Button id="getAQuoteDesktop1" type="button" className="btn btn-solid-green" onClick={() => this.addProduct(PRODUCT_COMPREHENSIVE_CAR)}>Get a quote</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-none d-xl-block d-lg-none">
                    <div id="carouselDesktop" className="carousel slide mt-4" data-ride="carousel" data-pause="hover" data-touch="true">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="carousels-background-desktop">
                                    <div className="row pb-3">
                                        <div className="col-lg-6 col-sm-6 mt-xl-2 mt-md-2 mt-sm-2 mt-2 ">
                                            <Image src="./images/image-carousel@2x.png" className="img-fluid" />
                                        </div>
                                        <div className="col-lg-6 col-sm-6 mt-xl-2 mt-md-2 mt-sm-2 mt-2 pl-0 pr-3">
                                            <h2 className="mb-2">Super cheap car<br /> insurance premiums</h2>
                                            <p>That decrease monthly</p>
                                            <Button id="getAQuoteDesktop2" type="button" className="btn btn-solid-green" onClick={() => this.addProduct(PRODUCT_COMPREHENSIVE_CAR)}>Get a quote</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="carousels-background d-block d-lg-none d-md-block pt-4 carousel-mobile-container">
                    <div className="container-fluid">
                        <div id="carouselMobile" className="carousel slide" data-ride="carousel" data-pause="hover" data-touch="true">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <div className="row">
                                        <div className="col-5 pl-0 mt-4">
                                            <Image className="p-xs-5 king-of-insurance-mobile mx-auto" src="./Images/image-carousel.png" />
                                        </div>
                                        <div className="col-7 mt-4">
                                            <h3 className="mb-2">Super cheap car insurance premiums</h3>
                                            <p className="mb-2">That decrease monthly</p>
                                            <Button id="getAQuoteMobile" type="button" className="btn btn-solid-green" onClick={() => this.addProduct(PRODUCT_COMPREHENSIVE_CAR)}>Get a quote</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ol className="carousel-indicators">
                            <li data-target="#carouselMobile" data-slide-to="0" className="active"></li>
                            <li data-target="#carouselMobile" data-slide-to="1"></li>
                            <li data-target="#carouselMobile" data-slide-to="2"></li>
                            <li data-target="#carouselMobile" data-slide-to="3"></li>
                        </ol>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAddProduct: (action) => dispatch(addProduct(action)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Carousel);